<script setup lang="ts"></script>

<template>
  <div>HOME VIEW</div>
</template>

<style scoped></style>
